import { CHANGE_APPLY_METHOD } from './change-apply-method';
import { CONSENT_MANAGER } from './consent-manager';
import { CUSTOMER_SERVICE_MODAL } from './customer-service-modal';
import { FOOTER } from './harmonised-footer';
import { CANDIDATE_PROFILE_EVENTS, HEADER, RECRUITER_SPACE_EVENTS } from './harmonised-header';
import { SEARCH_BAR } from './harmonised-search-bar';
import { JOB_AGENT } from './job-agent';
import { JOB_AGENT_LEGACY } from './job-agent-legacy';
import { JOB_APPLY_BUTTON } from './job-apply-button';
import { JOB_APPLY_METHOD_SSR } from './job-apply-method-ssr';
import { LISTING_SALARY_WIDGET } from './listing-salary-widget';
import { MEDIA_LIBRARY } from './media-library';
import { MYA } from './mya';
import { ONE_ADMIN } from './one-admin';
import { RECRUITER_CARD } from './recruiter-card';
import { RECRUITER_HUB } from './recruiter-hub';
import { RECRUITER_PROFILE_EDITOR } from './recruiter-profile-editor';
import { RECRUITER_SPACE_LISTINGS } from './recruiter-space-listings';
export var EVENT_TYPES = {
    CANDIDATE_PROFILE_EVENTS: CANDIDATE_PROFILE_EVENTS,
    CHANGE_APPLY_METHOD: CHANGE_APPLY_METHOD,
    CONSENT_MANAGER: CONSENT_MANAGER,
    CUSTOMER_SERVICE_MODAL: CUSTOMER_SERVICE_MODAL,
    FOOTER: FOOTER,
    HEADER: HEADER,
    JOB_AGENT_LEGACY: JOB_AGENT_LEGACY,
    JOB_AGENT: JOB_AGENT,
    JOB_APPLY_BUTTON: JOB_APPLY_BUTTON,
    JOB_APPLY_METHOD_SSR: JOB_APPLY_METHOD_SSR,
    LISTING_SALARY_WIDGET: LISTING_SALARY_WIDGET,
    MEDIA_LIBRARY: MEDIA_LIBRARY,
    MYA: MYA,
    ONE_ADMIN: ONE_ADMIN,
    RECRUITER_CARD: RECRUITER_CARD,
    RECRUITER_HUB: RECRUITER_HUB,
    RECRUITER_PROFILE_EDITOR: RECRUITER_PROFILE_EDITOR,
    RECRUITER_SPACE_EVENTS: RECRUITER_SPACE_EVENTS,
    RECRUITER_SPACE_LISTINGS: RECRUITER_SPACE_LISTINGS,
    SEARCH_BAR: SEARCH_BAR,
};
//# sourceMappingURL=index.js.map